import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TrustBox } from '@common/util-models';

@Component({
  selector: 'sales-trust-pilot',
  templateUrl: './trust-pilot.component.html',
  styleUrls: ['./trust-pilot.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrustPilotComponent {
  TrustBox = TrustBox;
}
